<template>
  <div class="counter-wrapper">
    <!-- 数量选择控件 -->
    <el-popover
      placement="top"
      width="auto"
      trigger="hover"
      v-model="popoverVisible"
    >
      <!-- 弹出的选项 -->
      <div class="popover-options">
        <el-button
          v-for="option in options"
          :key="option"
          size="mini"
          @click="selectOption(option)"
        >
          {{ option }}
        </el-button>
      </div>
      <!-- 输入框和按钮 -->
      <div slot="reference" class="counter-input">
        <!-- 加号按钮 -->
        <el-button size="mini" @click="increment">+</el-button>
        <!-- 输入框 -->
        <el-input
          v-model.number="inputValue"
          type="number"
          size="mini"
          class="input-field"
          @input="inputClick"></el-input>
        <!-- 减号按钮 -->
        <el-button size="mini" @click="decrement">-</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'CounterInput', // 组件名称
  props: {
    initialValue: {
      type: Number,
      default: 1 // 默认值
    },
    options: {
      type: Array,
      default: () => [5, 10, 20] // 默认选项值
    }
  },
  data () {
    return {
      inputValue: this.initialValue, // 初始值
      popoverVisible: false // 控制 Popover 显示
    }
  },
  methods: {
    reset () {
      this.inputValue = 1
    },
    // 点击选项时设置输入框的值
    selectOption (value) {
      this.inputValue = value
      this.popoverVisible = false // 选完隐藏弹出框
      this.$emit('input', this.inputValue) // 更新父组件的数据
    },
    // 加号按钮点击
    increment () {
      this.inputValue++
      this.$emit('input', this.inputValue) // 更新父组件的数据
    },
    // 减号按钮点击
    decrement () {
      if (this.inputValue > 1) this.inputValue-- // 避免负值
      this.$emit('input', this.inputValue) // 更新父组件的数据
    },
    inputClick () {
      this.$emit('input', this.inputValue) // 更新父组件的数据
    }
  }
}
</script>

<style scoped>
.counter-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.counter-input {
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  overflow: hidden;
}

.counter-input .el-button {
  margin: 0;
  border: none;
  background-color: #f5f5f5;
}

.input-field {
  text-align: center;
  width: 80px; /* 输入框宽度 */
  /*pointer-events: none;*/ /* 禁止用户直接输入 */
}

.popover-options {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CounterInput.vue